<template>
	<el-upload
		name="upload"
		class="cbs-upload"
		v-on="$listeners"
		v-bind="computedAttrs"
		:action="uploadUrl"
		:show-file-list="false"
		:on-progress="showLoading"
		:on-error="handleOnUploadError"
		:on-success="handleOnUploadSuccess"
	>
		<div
			:class="{
				'upload-trigger': true,
				'mr-3 mb-3': fileList && fileList.length > 0
			}"
			slot="trigger"
		>
			<i slot="default" class="el-icon-plus"></i>
		</div>

		<div class="file-item" v-for="(file, index) in fileList" :key="index">
			<img v-if="fileIsImage(file.response.extension)" class="file-item__thumbnail image responsive" :src="file.response.path" />
			<span v-else class="file-item__thumbnail">{{ file.response.file_name }}</span>
			<span class="actions file-item__actions">
				<span class="actions__delete" @click="handleRemove(file)">
					<i class="el-icon-delete"></i>
				</span>
			</span>
		</div>
	</el-upload>
</template>

<script>
import _ from "lodash";

export default {
	name: "CbsUpload",
	inheritAttrs: false,
	props: {
		uploadedFiles: {
			type: Array,
			validator: prop => {
				if (prop.length) {
					return !prop.some(item => {
						const response = _.get(item, "response");
						const isValidResponseObject = _.get(response, "id") && _.get(response, "path") && _.get(response, "extension") && _.get(response, "file_name");

						return !response || !isValidResponseObject;
					});
				}
				return true;
			},
			default: () => []
		},
		isMultiple: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			uploadUrl: process.env.VUE_APP_UPLOAD_FILE_ENDPOINT,
			fileList: this.uploadedFiles || []
		};
	},
	computed: {
		computedAttrs: function() {
			if(this.$attrs.multiple) {
				return Object.assign(
					{},
					this.$attrs,
					{
						multiple: false
					}
				);
			}
			return this.$attrs;
		}
	},
	watch: {
		fileList() {
			this.$emit("onChangeFileList", this.fileList);
		},
		uploadedFiles() {
			if(JSON.stringify(this.fileList) !== JSON.stringify(this.uploadedFiles)) {
				this.fileList = this.uploadedFiles;
			}
		}
	},
	methods: {
		handleRemove(file) {
			this.fileList = this.fileList.filter(item => item.response.id !== file.response.id);
		},
		handleOnUploadSuccess(response, file) {
			this.fileList = this.isMultiple ? [...this.fileList, file] : [file];
			this.hideLoading();
		},
		handleOnUploadError(error) {
			this.$helper.notifyError({ context: this, error });
			this.hideLoading();
		},
		fileIsImage(extension) {
			return ["jpg", "jpeg", "ico", "png"].includes(extension);
		},
		showLoading() {
			this.$vs.loading();
		},
		hideLoading() {
			this.$nextTick(() => {
				this.$vs.loading.close();
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.cbs-upload {
	display: flex;
	flex-wrap: wrap;

	.upload-trigger {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;

		i {
			font-size: 28px;
		}

		&:hover,
		&:focus {
			border-color: var(--color-solid-primary);
		}
	}

	.upload-trigger,
	.file-item {
		width: 140px;
		height: 140px;
	}

	.file-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		position: relative;
		border-radius: 6px;
		margin: 0 8px 8px 0;
		border: 1px solid #c0ccda;

		.file-item__thumbnail {
			text-align: center;

			&.image {
				width: 100%;
				height: 100%;
			}
		}

		.actions {
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0;
			text-align: center;
			color: #fff;
			opacity: 0;
			font-size: 20px;
			background-color: rgba(0, 0, 0, 0.5);
			transition: opacity 0.3s;

			&:hover {
				opacity: 1;
			}

			span {
				cursor: pointer;
			}
		}
	}
}
</style>
